const products = [
  {
    id: 2,
    name: "Sunflower half ",
    price: 299,
    description:
      "Stylized sunflower design with a natural touch for romantic spaces.",
    category: "Decor",
  },
  {
    id: 3,
    name: "Galaxy Sphere",
    price: 120,
    description:
      "A swirling galaxy orb, perfect for ambient lighting and mood setting.",
    category: "Decor",
  },
  {
    id: 1,
    name: "Panda",
    price: 90,
    description:
      "Cute panda-shaped piece that adds charm to your shelf or workspace.",
    category: "Decor",
  },
  {
    id: 4,
    name: "Crystal Nest",
    price: 130,
    description:
      "Transparent cube with textured inner layers for a modern look.",
    category: "Decor",
  },
  {
    id: 5,
    name: "Velvet Cube",
    price: 160,
    description: "Soft square with smooth matte finish and subtle aroma hints.",
    category: "Decor",
  },

  // Toys
  {
    id: 6,
    name: "Tiny Dino",
    price: 60,
    description: "Fun dinosaur figure ideal for kids' rooms or playful setups.",
    category: "Toys",
  },
  {
    id: 7,
    name: "Bubble Bear",
    price: 200,
    description: "Chunky bear in bubbly shape, perfect for playful settings.",
    category: "Toys",
  },
  {
    id: 8,
    name: "Choco Bunny",
    price: 170,
    description: "Bunny with a chocolate-like texture that sparks imagination.",
    category: "Toys",
  },
  {
    id: 9,
    name: "Mini Cactus",
    price: 40,
    description:
      "A lively cactus look-alike, ideal for tiny toy garden scenes.",
    category: "Toys",
  },
  {
    id: 10,
    name: "Gummy Cat",
    price: 190,
    description: "Looks like a giant gummy treat, perfect for toy displays.",
    category: "Toys",
  },

  // Gifts
  {
    id: 11,
    name: "Pastel Twist",
    price: 110,
    description:
      "Twisted spiral with pastel colors, ideal as a thoughtful gift.",
    category: "Gifts",
  },
  {
    id: 12,
    name: "Berry Pop",
    price: 180,
    description: "Vibrant and fruity-inspired, a fun pick for gift hampers.",
    category: "Gifts",
  },
  {
    id: 13,
    name: "Marsh Swirl",
    price: 150,
    description: "Soft marshmallow-like structure, cozy and unique gift idea.",
    category: "Gifts",
  },
  {
    id: 14,
    name: "Luxe Petal",
    price: 100,
    description:
      "High-end floral design with premium finish for special occasions.",
    category: "Gifts",
  },
  {
    id: 15,
    name: "Frost Heart",
    price: 130,
    description: "Shiny heart with frosted look, makes a perfect love token.",
    category: "Gifts",
  },

  // Aromatherapy
  {
    id: 16,
    name: "Citrus Drop",
    price: 120,
    description: "Fresh citrus-inspired piece with a refreshing scent profile.",
    category: "Aromatherapy",
  },
  {
    id: 17,
    name: "Lavender Mist",
    price: 190,
    description: "Smooth exterior infused with calming lavender essence.",
    category: "Aromatherapy",
  },
  {
    id: 18,
    name: "Mint Leaf",
    price: 170,
    description: "Crisp design with minty undertones to awaken your space.",
    category: "Aromatherapy",
  },
  {
    id: 19,
    name: "Ocean Drift",
    price: 160,
    description: "Cool tones and ocean scent for a tranquil room vibe.",
    category: "Aromatherapy",
  },
  {
    id: 20,
    name: "Vanilla Cream",
    price: 140,
    description:
      "Warm and sweet, this is a gentle scent companion for quiet moments.",
    category: "Aromatherapy",
  },

  // Seasonal
  {
    id: 21,
    name: "Pumpkin Spice",
    price: 110,
    description: "Fall-inspired piece with warm spice tones and cozy charm.",
    category: "Seasonal",
  },
  {
    id: 22,
    name: "Snowflake Charm",
    price: 130,
    description: "Delicate snowflake design for festive winter displays.",
    category: "Seasonal",
  },
  {
    id: 23,
    name: "Maple Ember",
    price: 100,
    description:
      "Inspired by falling leaves, adds autumnal vibes to any corner.",
    category: "Seasonal",
  },
  {
    id: 24,
    name: "Berry Noel",
    price: 150,
    description: "Holiday berry design with subtle pine scent undertones.",
    category: "Seasonal",
  },
  {
    id: 25,
    name: "Sun Bloom",
    price: 190,
    description:
      "Bright and sunny floral piece, perfect for spring or summer decor.",
    category: "Seasonal",
  },
];

export default products; // Exporting the products array
